import React from "react";

/**
 * First visible split-column choice cell in render order (standard or transposed grid),
 * respecting shouldHideCell. Used so question title/label attach only to that cell (role="group"
 * aria-labelledby in GridRenderer), not concatenated on the interactive control.
 */
export type ChoiceGridFirstAriaLeadCellCoords = {
    rowIndex: number;
    colIndex: number;
    choiceElementId: string;
    variableId: number;
};

/** Set once per Choice / Image-choice / Hybrid grid table in GridRenderer (StandardGrid). */
export const ChoiceGridFirstAriaLeadCellContext = React.createContext<
    ChoiceGridFirstAriaLeadCellCoords | null | undefined
>(undefined);

export function useChoiceGridFirstAriaLeadCellCoords():
    | ChoiceGridFirstAriaLeadCellCoords
    | null
    | undefined {
    return React.useContext(ChoiceGridFirstAriaLeadCellContext);
}
